"use client";

import * as React from "react";
import { cn } from "@/utils";

interface StatCardProps {
  label: string;
  value?: React.ReactNode;
  sublabel?: string;
  isLoading?: boolean;
  className?: string;
}

export function StatCard({
  label,
  value,
  sublabel,
  isLoading,
  className,
}: StatCardProps) {
  return (
    <div className={cn("lhx-card px-5 py-4", className)}>
      <p className="label-caps">{label}</p>
      <div className={cn("mt-2", { "animate-pulse": isLoading })}>
        {isLoading ? (
          <div className="h-9 w-36 rounded bg-surface-400" />
        ) : (
          <p className="stat-value hex-gradient-text">{value ?? "—"}</p>
        )}
        {sublabel && !isLoading && (
          <p className="mt-1 text-xs text-muted">{sublabel}</p>
        )}
      </div>
    </div>
  );
}

export default StatCard;
